import { Component, ViewModel, View, ObservableArray } from "binder";
import  { TableView } from "./table-view"

export class TableViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new TableView();
    }
    public getTypeId(): string {
        return "VM-E1AB6D64-300F-476E-97D6-0BA112987036"
    }

    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    
}
